// A country choice made on the other site (country selector or this pop-up's switch button) arrives
// as a URL parameter, since localStorage isn't shared between ecoatm.com and ecoatm.ca. Save it
// before the pop-up checks for a stored choice, then drop the parameter from the address bar.
(function saveCountryChoiceFromUrl() {
  const url = new URL(window.location.href);
  const choice = url.searchParams.get(COUNTRY_CHOICE_URL_PARAM);
  if (!choice) return;

  if (['manual_selection', 'switched'].includes(choice)) {
    try {
      window.localStorage.setItem(COUNTRY_POPUP_STORAGE_KEY, choice);
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - the pop-up may re-show, which is an acceptable fallback
    }
  }

  url.searchParams.delete(COUNTRY_CHOICE_URL_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());
})();

if (!customElements.get('country-suggestion-modal')) {
  customElements.define(
    'country-suggestion-modal',
    class CountrySuggestionModal extends ModalDialog {
      constructor() {
        super();
        this.siteCountry = this.dataset.siteCountry;
        this.otherCountry = this.dataset.otherCountry;

        const switchButton = this.querySelector('.country-suggestion-modal__switch-button');
        const stayButton = this.querySelector('.country-suggestion-modal__stay-button');

        if (switchButton) switchButton.addEventListener('click', this.onSwitchClick.bind(this));
        if (stayButton) stayButton.addEventListener('click', this.onStayClick.bind(this));

        this.maybeShow();
      }

      isBot() {
        if (navigator.webdriver) return true;
        return /bot|crawl|spider|slurp|googlebot|bingbot|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|semrushbot|ahrefsbot|mj12bot|petalbot|bytespider|applebot|lighthouse|headless/i.test(
          navigator.userAgent || ''
        );
      }

      hasChosen() {
        try {
          return window.localStorage.getItem(COUNTRY_POPUP_STORAGE_KEY) !== null;
        } catch (error) {
          return false;
        }
      }

      persistChoice(choice) {
        try {
          window.localStorage.setItem(COUNTRY_POPUP_STORAGE_KEY, choice);
        } catch (error) {
          // localStorage unavailable (private browsing, etc.) - the pop-up may re-show, which is an acceptable fallback
        }
      }

      trackEvent(action) {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'country_suggestion_popup',
          action: action,
          site: this.siteCountry,
          detected_country: this.detectedCountry,
        });
      }

      maybeShow() {
        if (this.isBot() || this.hasChosen() || !this.siteCountry || !this.otherCountry) return;
        if (!window.Shopify || !window.Shopify.routes) return;

        const root = window.Shopify.routes.root || '/';
        const url = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${this.siteCountry}`;

        fetch(url)
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            const detected = data && data.detected_values && data.detected_values.country;
            if (!detected || !detected.handle) return;

            this.detectedCountry = detected.handle;
            if (detected.handle === this.otherCountry) {
              this.show(document.body);
              this.trackEvent('shown');
            }
          })
          .catch(() => {});
      }

      onSwitchClick(event) {
        this.persistChoice('switched');
        this.trackEvent('switch');

        // Carry the choice to the destination site too (see saveCountryChoiceFromUrl above).
        const link = event.currentTarget;
        const url = new URL(link.href, window.location.href);
        url.searchParams.set(COUNTRY_CHOICE_URL_PARAM, 'switched');
        link.href = url.toString();
      }

      onStayClick() {
        this.hide();
      }

      hide() {
        this.persistChoice('stayed');
        this.trackEvent('dismissed');
        super.hide();
      }
    }
  );
}
